import React from 'react';

import { isEmpty } from 'ramda';

import FilesAdapter from 'components/Pages/Admin/PageTypes/Property/Resources/Upload/FilesAdapter';

import { GUEST_PORTAL_ASSET_RECOMMENDED_MAX_SIZE } from '../../../shared/functions';
import styles from './index.module.css';
import * as types from './types';

import Upload from './index';

function DocumentsAdapter({
  value,
  onChange,
  fileCategory,
  documentsType,
  maxFileSize,
  recommendedFileSize = GUEST_PORTAL_ASSET_RECOMMENDED_MAX_SIZE,
  placeholder = 'No Document Added Yet',
  buttonActionType = 'upload',
  renderButtonText,
  disabled,
  uploadAlertText,
}: types.Props) {
  return (
    <FilesAdapter
      value={value}
      onChange={onChange}
      fileCategory={fileCategory}
      maxFileSize={maxFileSize}
      recommendedFileSize={recommendedFileSize}
      withDivider
      contentWrapperClassName={styles.listWrapper}
      addActionDisabled={disabled}
      customStyleKey="custom-documents"
      uploadAlertText={uploadAlertText}
      renderEmptyComponent={(onUpload: any) => (
        <Upload
          buttonActionType={buttonActionType}
          renderButtonText={renderButtonText}
          onOpenModal={onUpload}
          maxFileSize={maxFileSize}
          recommendedFileSize={recommendedFileSize}
          contentType={documentsType}
          placeholder={placeholder}
          isFilesEmpty={isEmpty(value)}
        />
      )}
    />
  );
}

export { DocumentsAdapter };
export default DocumentsAdapter;
